const boot = {
  on: {
    "": [{ target: "details" }],
  },
};

const details = {
  meta: { path: "/apply", step: 1 },
  on: {
    NEXT: {
      target: "verification",
    },
  },
};

const verification = {
  meta: { path: "/apply/verification", step: 2 },
  on: {
    NEXT: "personal",
    BACK: "details",
  },
};

const personal = {
  meta: { path: "/apply/personal", step: 3 },
  on: {
    NEXT: "skills",
    BACK: "verification",
  },
};

const skills = {
  meta: { path: "/apply/skills", step: 4 },
  on: {
    NEXT: {
      target: "selectInstagramPhotos",
    },
    BACK: "personal",
  },
};


const instagram = {
  meta: { path: "/apply/instagram", step: 5 },
  initial: "connectAccount",
  states: {
    connectAccount: {
      on: {
        NO_ACCOUNT: "noAccount",
      },
    },
    noAccount: {
      meta: { path: "/apply/no-account" },
      on: {
        NO_ACCOUNT: "noAccountFinal",
      },
    },
    noAccountFinal: {
      meta: { path: "/apply/no-account-final" },
    },
  },
  on: {
    FAIL: {
      target: "fail",
    },
    CONNECT: {
      target: "selectInstagramPhotos",
    },
    BACK: "skills",
  },
};

const selectInstagramPhotos = {
  meta: { path: "/apply/photos", step: 6 },

  on: {
    LOAD_MORE: "selectInstagramPhotos",
    NEXT: process.env.REACT_APP_MEMBERSHIP_SELECTION_ENABLED === 'true' ? "checkoutMembership" : "complete",
    // Used to send member back to connect page, if no usable instagram yet.
    CONNECT_INSTAGRAM: "instagram",
    BACK: "skills",
  },
};

const checkoutMembership = {
  meta: { path: "/apply/membership", step: 7 },

  on: {
    NEXT: "complete",
    BACK: "selectInstagramPhotos",
  },
};

const verifyEmail = {
  meta: { path: "/apply/verify-email/:code", step: 3 },
};

const complete = {
  meta: { path: "/apply/complete" },
};

const fail = {
  meta: { path: "/apply/fail" },
};

const apply = {
  initial: "boot",
  context: { images: [] },
  states: {
    boot,
    details,
    personal,
    skills,
    instagram,
    selectInstagramPhotos,
    checkoutMembership,
    verification,
    verifyEmail,
    complete,
    fail,
  },
};

export default apply;
